export const CHART_COLORS = {
  signups: '#0d6efd',
  onboarded: '#6f42c1',
  firstArticle: '#198754',
  firstDeposit: '#fd7e14',
  deposits: '#198754',
  spend: '#ffc107',
  balance: '#0dcaf0',
  articlesAi: '#6610f2',
  articlesImport: '#20c997',
  articlesTotal: '#6610f2',
};

export const baseChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top' as const, labels: { boxWidth: 12, font: { size: 11 } } },
    tooltip: { mode: 'index' as const, intersect: false },
  },
  scales: {
    x: { grid: { display: false }, ticks: { maxTicksLimit: 12, font: { size: 10 } } },
    y: { beginAtZero: true, ticks: { font: { size: 10 } } },
  },
  elements: { point: { radius: 2 }, line: { tension: 0.3 } },
};

export const stackedBarOptions = {
  ...baseChartOptions,
  scales: {
    x: { ...baseChartOptions.scales.x, stacked: true },
    y: { ...baseChartOptions.scales.y, stacked: true },
  },
};

export function lineDataset(label: string, data: number[], color: string) {
  return {
    label,
    data,
    borderColor: color,
    backgroundColor: color + '20',
    fill: false,
    borderWidth: 2,
  };
}

export function barDataset(
  label: string,
  data: number[],
  color: string,
  opts?: { stack?: string },
) {
  return {
    label,
    data,
    backgroundColor: color + 'cc',
    borderColor: color,
    borderWidth: 1,
    stack: opts?.stack,
  };
}
